export class TextSizePerformGrow {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get performer() {
        return this.parent;
    }
    get allBorders() {
        return this.performer.borders;
    }
    get groupItems() {
        return this.performer.groupItems;
    }
    get hasReachedMaximumFontsize() {
        return this.groupItems.currentScaledFontSize >= this.groupItems.maxFontSize;
    }
    get isBelowMinimumFontsize() {
        if (!this.performer.group.globalTextsizer.isMasterSizer)
            return false;
        return this.groupItems.currentScaledFontSize < this.groupItems.minFontSize;
    }
    growLoop() {
        this.allBorders.saveCompareState();
        this.growUntilBorderIsExceeded();
        // this.undoFinalGrow(); is done by shrink loop
    }
    growUntilBorderIsExceeded() {
        let shouldStop = false;
        this.performer.doesExceedBorder = this.allBorders.doesExceedBorder;
        for (let i = 0; i < this.performer.MAX_LOOPS && !this.hasReachedMaximumFontsize && !shouldStop; i++) {
            if (i > 0) {
                this.performer.doesExceedBorder = this.allBorders.doesExceedBorder;
            }
            if (!this.performer.doesExceedBorder || this.isBelowMinimumFontsize) {
                this.growOneStep();
            }
            else {
                shouldStop = true;
            }
        }
    }
    growOneStep() {
        this.allBorders.saveCompareState();
        this.groupItems.increaseFontSize();
    }
}
